import { FeedbackApi } from 'helpers/api/feedback';
import { FEEDBACK_SET_LIST, FEEDBACK_SET_QUESTIONS } from './actionTypes';

export const Feedback = {
  getFeedbackList: (queryParams) => async (dispatch) => {
    dispatch(Feedback.setFeedbackList(null));
    FeedbackApi.feedbackList(queryParams || {})
      .then(({ data } = {}) => {
        dispatch(Feedback.setFeedbackList(data));
      })
      .catch(() => dispatch(Feedback.setFeedbackList([])));
  },

  getQuestionsList: () => async (dispatch) => {
    dispatch(Feedback.setQuestionList(null));

    FeedbackApi.feedbackQuestionsList()
      .then(({ data } = {}) => {
        dispatch(Feedback.setQuestionList(data));
      })
      .catch(() => dispatch(Feedback.setQuestionList([])));
  },

  setFeedbackList: (payload) => ({
    type: FEEDBACK_SET_LIST,
    payload,
  }),

  setQuestionList: (payload) => ({
    type: FEEDBACK_SET_QUESTIONS,
    payload,
  }),
};
